import { useState } from "react";
import profile_info from '../../src/assets/Profile_Info.gif';
import download_pass from '../../src/assets/Download_Pass.gif';
import change_language from '../../src/assets/Change_Language.gif';
import search_med from '../../src/assets/Search_Med.gif';
import Nav from "../comps/nav";
import Footer from "../comps/footer";

const steps = [
    {
        title: "Signing Up",
        items: [
            {
                gif: null,
                content: "To get started, after downloading the app, create an account by clicking the 'Sign Up' button on the landing screen. This will prompt you to enter your first and last name, email, and create a password. After signing up, you will receive a verification email with a six-digit code that you will need to enter in the app to verify your email address. Once verified, you can log in and start using the app!"
            },
            {
                gif: null,
                content: "If there was an error, or you weren't able to verify your email at the time of signing up, you can navigate back to the 'Log In' screen and sign in with your email and password. Afterwards, a new code will be sent to you, and you will automatically be directed to a page where you can re-enter the code to verify your email."
            }
        ]
    },
    {
        title: "Setting Up Your Profile",
        items: [
            {
                gif: profile_info,
                content: "After logging in, navigate to the profile page using the navigation bar at the bottom of the screen. Here, you can input any information you want. The more you fill out, the more useful the Medical ID pass will be.\n\nYou can also create a Medical ID pass for someone else, such as a family member who may not be as tech-savvy. Just fill out their information, generate the pass, and send it to yourself. You can then share the link with them.\n\nIf they don't have an email, you can still create the pass for them and send it to yourself. Just make sure to keep the link safe so they can access it when needed.\n\n(Note: The Medical ID pass includes medications that are added in the app, so make sure to add any medications you want to appear on the pass in the 'Medications' section of the profile page. While it is possible to make a pass for someone else, it is recommended to create an account for them if possible so they can update it themselves in the future.)"
            }
        ]
    },
    {
        title: "Downloading Your Medical ID Pass",
        items: [
            {
                gif: download_pass,
                content: "To download your Medical ID pass:\n- Go to the profile page\n- Press the gear icon\n- Click 'Download Pass'\nIt may take a minute, but when you get the email—whether you made it for yourself or someone else—click the link, and you will be prompted to add it to your wallet."
            }
        ]
    },
    {
        title: "Searching for Medications",
        items: [
            {
                gif: search_med,
                content: "Use the search feature to look up drugs, products, and supplements.\n\n(Note: There may be multiple entries for the same medication, so only the first is shown, and it may not be the exact one you have.)"
            },
            {
                gif: change_language,
                content: "Change the app language to your preference for easier navigation."
            }
        ]
    },
];

export default function HowToUse() {
    const [openIndex, setOpenIndex] = useState<number | null>(null);

    return (
        <main className="min-h-screen bg-[#f2f4f5] pb-12">
            <Nav />
            <section className="relative px-4 pt-12 pb-12">
                <h1 className="text-4xl font-bold mb-8 text-center">How to Use AMII</h1>
                <div className="flex justify-center">
                    <div className="w-full md:w-4/5">
                        {steps.map((step, idx) => (
                            <div key={idx} className="mb-4 border rounded-lg">
                                <button
                                    className="w-full text-left px-4 py-3 font-semibold bg-gray-100 hover:bg-gray-200"
                                    onClick={() => setOpenIndex(openIndex === idx ? null : idx)}
                                >
                                    {step.title}
                                </button>
                                <div
                                    className={
                                        `overflow-hidden transition-all duration-500 ease-in-out ` +
                                        (openIndex === idx
                                            ? 'max-h-[1000px] opacity-100 scale-y-100'
                                            : 'max-h-0 opacity-0 scale-y-95')
                                    }
                                    style={{ transitionProperty: 'max-height, opacity, transform' }}
                                >
                                    <div className="flex px-4 py-3 bg-white text-gray-700 gap-6">
                                        <div className="basis-[100%] flex flex-col gap-6">
                                            {step.items.map((item, itemIdx) => (
                                                <div
                                                    key={itemIdx}
                                                    className="flex items-center gap-4 md:flex-row flex-col md:gap-4"
                                                >
                                                    {/*left: image on top for mobile, left for desktop*/}
                                                    {item.gif && (
                                                        <img
                                                            src={item.gif}
                                                            alt={step.title + " demo " + (itemIdx + 1)}
                                                            className="md:basis-[20%] w-full md:w-auto max-h-80 object-contain rounded mb-2 md:mb-0"
                                                        />
                                                    )}
                                                    {/*right: text below image on mobile, right of image on desktop*/}
                                                    <p className={item.gif ? "md:basis-[80%] text-left w-full" : "w-full text-center"}>
                                                        {item.content.split('\n').map((line, i, arr) => (
                                                            <span key={i}>
                                                                {line}
                                                                {i < arr.length - 1 && <br />}
                                                            </span>
                                                        ))}
                                                    </p>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
            <Footer/>
        </main>
    );
}
